import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../servicios/api/api.service';
import { fuenteI } from '../../../modelos/fuentes.interface';
import { NivelSuperv } from 'src/app/modelos/nivelSupervicon.interface';
import { TipoCredito } from 'src/app/modelos/tipoCredito.interface';
import { SolucViv } from 'src/app/modelos/solucionViv.interface';
import { RangViv } from 'src/app/modelos/rangoViv.interface';
import { Tenedor } from 'src/app/modelos/tenedor.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Fte_Parm } from 'src/app/modelos/fuenteParam';
import { FuenteParametroI } from 'src/app/modelos/FuenteParametro';
import { FuenteVariableI } from 'src/app/modelos/FuenteVariable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-adminvariablesfivi',
  templateUrl: './adminvariablesfivi.component.html',
  styleUrls: ['./adminvariablesfivi.component.css']
})
export class AdminvariablesfiviComponent implements OnInit {

  btnguardar : Boolean;
  nuevoFteParam : Boolean;
  editarFteParam : Boolean;
  datosEditFuente : fuenteI;
  FuenteParametrica : FuenteParametroI[];
  FuenteParametricaEditar : FuenteParametroI = new FuenteParametroI;
  NombreParametricaEditar : string = "";
  ItemsFuenteParametrica : FuenteVariableI[];
  FuenteVariableEditar : FuenteVariableI = new FuenteVariableI;
  NombreVariableEditar : string = "";

  page : number;

  @ViewChild('closemodalconfirma') closemodalconfirma: ElementRef;
  @ViewChild('openmodalitems') openmodalitems: ElementRef;
  @ViewChild('closemodalitems') closemodalitems: ElementRef;
  @ViewChild('openmodalconfirvaria') openmodalconfirvaria: ElementRef;
  @ViewChild('closemodalconfirvaria') closemodalconfirvaria: ElementRef;

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    let fuenteId = this.activerouter.snapshot.paramMap.get('id');
    this.btnguardar = true;
    this.nuevoFteParam = false;
    this.editarFteParam = false;
    this.datosEditFuente = new fuenteI;
    this.api.getFuenteById(fuenteId).subscribe(data=>{
      this.datosEditFuente = data;
    });
    this.api.getParametrosFteFivi(fuenteId).subscribe(data1=>{
      this.FuenteParametrica = data1;
    });
  }

  CambioObligatoriedad(FtePara:FuenteParametroI){
    this.NombreParametricaEditar = FtePara.parametrica.nombre;
    this.FuenteParametricaEditar = FtePara;
  }

  Regresar(){
    this.router.navigate(['variablesfivi']);
  }

  guardar(){
    this.api.guardarFteParam(this.FuenteParametricaEditar).subscribe(data2=>{
      if(data2){
        this.toastr.success('Cambio guardado.', 'OK!');
        this.closemodalconfirma.nativeElement.click();
        this.ngOnInit();
      }
    });
  }

  ItemsParametrica(FtePara:FuenteParametroI){
    this.btnguardar = true;
    this.openmodalitems.nativeElement.click();
    this.NombreParametricaEditar = FtePara.parametrica.nombre;
    this.FuenteParametricaEditar = FtePara;
    this.api.getVariablesFte(this.FuenteParametricaEditar).subscribe(data2=>{
      this.ItemsFuenteParametrica = data2;
    });
  }

  CambioObligatoriedadItem(FteVaria:FuenteVariableI){
    this.FuenteVariableEditar = { ...FteVaria };
    this.NombreVariableEditar = FteVaria.variable.nombre;
    this.closemodalitems.nativeElement.click();
    this.closemodalconfirma.nativeElement.click();
    this.openmodalconfirvaria.nativeElement.click();
  }

  guardarItem(){
    this.btnguardar = false;
    this.api.guardarFteVaria(this.FuenteVariableEditar).subscribe(data3=>{
      if(data3){
        this.toastr.success('Cambio guardado.', 'OK!');
        this.closemodalconfirvaria.nativeElement.click();
        this.openmodalitems.nativeElement.click();
        this.ItemsParametrica(this.FuenteParametricaEditar);
      }
    });
  }

  regresar(){
    this.router.navigate(['variablesfivi']);
  }

}
